/**
 * Per-zone Grafana integration settings.
 *
 * `Zone.grafana_dashboard_url` was extracted out of `core.Zone` into the
 * `grafana_integration` plugin (BE commit `a841d00`, task #46): each
 * Zone now has at most one row in `GrafanaZoneSettings` carrying the
 * top-level dashboard URL. GET returns `{ dashboard_url: null }` for
 * zones that have never been configured (the BE returns an empty/
 * defaulted shape rather than 404 so the FE doesn't need a separate
 * "exists" check).
 *
 * Auth: same `ZoneMembership` gate as the LC equipment endpoints — the
 * shared `axiosInstance` JWT headers carry through unchanged.
 *
 * The analytics endpoint (`/cctv_core/{zone}/main/`) preserves its
 * `grafana_dashboard_url` field on the wire shape by design; this
 * helper is only for the Integrations Settings *editing* surface.
 */
import { axiosInstance } from './api';

export interface ZoneDashboardUrlDto {
  dashboard_url: string | null;
}

const dashboardUrlPath = (zoneId: string | number) =>
  `/grafana_integration/zones/${zoneId}/dashboard-url/`;

export const getZoneDashboardUrl = (zoneId: string | number) =>
  axiosInstance.get<ZoneDashboardUrlDto>(dashboardUrlPath(zoneId));

/**
 * PATCH the zone's Grafana dashboard URL.
 * Pass `null` (or an empty-trimmed string — caller is expected to
 * normalise) to clear the URL.
 */
export const setZoneDashboardUrl = (
  zoneId: string | number,
  dashboard_url: string | null,
) =>
  axiosInstance.patch<ZoneDashboardUrlDto>(dashboardUrlPath(zoneId), {
    dashboard_url,
  });
